<template>
  <div class="eventComp_mode_23 eventComp_mode_container" v-show="currThemeObj">
    <div class="tableScrollArea" ref="tableParentDom">
      <multiLevelFold_table
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsId="currSportsDetail.sportsId"
        :tabType="tabType"
        :tableMode="tableMode"
        :parentWidthPx="parentWidthPx"
        :isScrollFlag="isScrollFlag"
        :variableColWidthVw="variableColWidthVw"
        :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
        :defaultWidthVwNum="defaultWidthVwNum"
        :tableColumnData="tableColumnData"
        :tableData="tableData"
        :spanMethod="spanMethod"
        @toParentEvent="toParentEventHandler"
        v-show="tableData && tableData.length > 0"
      ></multiLevelFold_table>
    </div>
  </div>
</template>

<script>
// 适用： table_body中column列有合并单元格的（普通表格+每一列增加描边）未完成
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_23',
  components: {
    multiLevelFold_table,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    tabType: {
      type: String, //确定数据来自于 出场名单'startList'  || 本场数据'localData',
      default: '',
    },
    competitorType: {
      type: String, //竞赛者的类型 A || D || T,
      default: '',
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_23 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isScrollBottom: false,
      tableMode: 'eventComp_mode_23',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: null,
      tableCellDefaultWidthVw: 13.88,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      currModeObj: null,
      renderModeList: [
        {
          modeName: '', //从0开始计算
          variableColWidthVw: [],
          tableCellDefaultWidthVw: 11.1,
          sportsIdArr: ['DIV'],
          isTabType: 'startList',
        },
      ],
    }
  },
  beforeCreate() {},
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.onResizeEvent()
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (modeItem.isTabType) {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId) &&
                modeItem.isTabType === this.tabType
              ) {
                this.currModeObj = modeItem
              }
            } else {
              if (
                modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId)
              ) {
                this.currModeObj = modeItem
              }
            }
          })
        }
        // console.debug("tabType:", this.tabType, this.datas)

        // this.computedModeData(JSON.parse(JSON.stringify(this.datas)))
        const formatId = 'team_id'
        const datas = {
          data: [
            {
              start_order: 1,
              player_id: 'DIVMS2406000',
              player_name: '杨凌',
              player_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2406000.jpg',
              player_gender: 'M',
              player_birth_date: '2001-06-06',
              team_id: 'CHN',
              team_name: '中国',
              team_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/CHN.png',
            },
            {
              start_order: 2,
              player_id: 'DIVMS2406007',
              player_name: '王彬翰',
              player_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2406007.jpg',
              player_gender: 'M',
              player_birth_date: '2004-09-13',
              team_id: 'CHN',
              team_name: '中国',
              team_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/CHN.png',
            },
            {
              start_order: 9,
              player_id: 'DIVMS2405967',
              player_name: '黄子淦',
              player_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2405967.jpg',
              player_gender: 'M',
              player_birth_date: '1999-04-05',
              team_id: 'CHN',
              team_name: '中国',
              team_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/CHN.png',
            },

            {
              start_order: 4,
              player_id: 'DIVMS2403379',
              player_name: '金志旭',
              player_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2403379.jpg',
              player_gender: 'M',
              player_birth_date: '2001-03-26',
              team_id: 'KOR',
              team_name: '韩国',
              team_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/KOR.png',
            },
            {
              start_order: 5,
              player_id: 'DIVMS2403394',
              player_name: '申政伟',
              player_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2403394.jpg',
              player_gender: 'M',
              player_birth_date: '2001-11-15',
              team_id: 'KOR',
              team_name: '韩国',
              team_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/KOR.png',
            },
            {
              start_order: 8,
              player_id: 'DIVMS2403393',
              player_name: '姜旻赫',
              player_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2403393.jpg',
              player_gender: 'M',
              player_birth_date: '2003-05-28',
              team_id: 'KOR',
              team_name: '韩国',
              team_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/KOR.png',
            },
            {
              start_order: 6,
              player_id: 'DIVMS2402574',
              player_name: '卢贝',
              player_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2402574.jpg',
              player_gender: 'M',
              player_birth_date: '1996-11-22',
              team_id: 'GER',
              team_name: '德国',
              team_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/GER.png',
            },
            {
              start_order: 12,
              player_id: 'DIVMS2402580',
              player_name: '瓦尔德斯泰纳',
              player_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2402580.jpg',
              player_gender: 'M',
              player_birth_date: '2002-05-15',
              team_id: 'GER',
              team_name: '德国',
              team_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/GER.png',
            },
            {
              start_order: 7,
              player_id: 'DIVMS2404089',
              player_name: '曼恩',
              player_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2404089.jpg',
              player_gender: 'M',
              player_birth_date: '2002-11-15',
              team_id: 'USA',
              team_name: '美国',
              team_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/USA.png',
            },
            {
              start_order: 3,
              player_id: 'DIVMS2401376',
              player_name: '西田玲央',
              player_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2401376.jpg',
              player_gender: 'M',
              player_birth_date: '2000-07-16',
              team_id: 'JPN',
              team_name: '日本',
              team_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/JPN.png',
            },
            {
              start_order: 10,
              player_id: 'DIVMS2401394',
              player_name: '兼戸凯',
              player_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2401394.jpg',
              player_gender: 'M',
              player_birth_date: '2001-02-13',
              team_id: 'JPN',
              team_name: '日本',
              team_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/JPN.png',
            },
            {
              start_order: 11,
              player_id: 'DIVMS2405590',
              player_name: '马尔吉奥托·迪亚斯',
              player_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/participants/DIV/DIVMS2405590.jpg',
              player_gender: 'M',
              player_birth_date: '2002-07-08',
              team_id: 'BRA',
              team_name: '巴西',
              team_logo:
                'https://hyper-sports-dev-res.mixtmt.com/Games/WUSG31/organisations/BRA.png',
            },
          ],
          table_head: [
            {
              name: '顺序',
              desc: '',
              map_key_arr: ['start_order'],
            },
            {
              name: '国家',
              desc: '',
              map_key_arr: ['team_name'],
            },
            {
              name: '姓名',
              desc: '',
              map_key_arr: [
                'player_name',
                'player_logo',
                'player_gender',
                'player_birth_date',
                'team_name',
                'team_logo',
              ],
            },
            {
              name: '性别',
              desc: '',
              map_key_arr: ['player_gender'],
            },
            {
              name: '名字',
              desc: '',
              map_key_arr: ['player_name'],
            },
            {
              name: '性别',
              desc: '',
              map_key_arr: ['player_gender'],
            },
            {
              name: '名字',
              desc: '',
              map_key_arr: ['player_name'],
            },
            {
              name: '生日',
              desc: '',
              map_key_arr: ['player_birth_date'],
            },
          ],
          judge: null,
        }

        this.computedModeData(JSON.parse(JSON.stringify(datas)))
      })
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    toParentEventHandler(data) {
      console.debug(data)
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedModeData(data) {
      console.debug('computedModeData:', data, this.currModeObj)
      if (data && data.data) {
        this.tableTotal = data ? data.length : 0
        const table_headArr = data.table_head

        // 表头
        const headColumns = []
        table_headArr.forEach((colums, colIndex) => {
          if (colums && colums.map_key_arr.length > 0) {
            headColumns.push({
              colKey: colums.map_key_arr[0] ? colums.map_key_arr[0] : '',
              colTitle: colums.name ? colums.name : '',
            })
          }
        })

        const otherColumns = headColumns
        let customColumn = null
        let competitorType = this.competitorType

        if (competitorType === 'T') {
          customColumn = {
            prop: 'teamLogo-teamName', //fristColumnPropArr.join('-'),
            label: '国家/地区',
            // widthVw:
            //   this.currModeObj.variableColWidthVw[
            //     this.currModeObj.sportsIdArr.indexOf(
            //       this.currSportsDetail.sportsId
            //     )
            //   ], //对应列的宽度，单位vw
            className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
            // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          }
        } else {
          let playerProp =
            'playerName-playerLogo-playerGender-teamLogo-teamName'
          let playerClassName = 'columnPlayerGroupClass'

          customColumn = {
            prop: playerProp, //fristColumnPropArr.join('-'),
            label: '运动员',
            // widthVw:
            //   this.currModeObj.variableColWidthVw[
            //     this.currModeObj.sportsIdArr.indexOf(
            //       this.currSportsDetail.sportsId
            //     )
            //   ], //对应列的宽度，单位vw
            className: playerClassName, //单独定制的头部样式class
            // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          }
        }
        if (this.tableColumnData.length == 0) {
          let tableColumnData = []
          if (this.currModeObj.tableCellDefaultWidthVw) {
            this.tableCellDefaultWidthVw =
              this.currModeObj.tableCellDefaultWidthVw
          }
          let widthVw = this.tableCellDefaultWidthVw
          for (let i = 0; i < otherColumns.length; i++) {
            const item = otherColumns[i]
            if (['运动员', '姓名', '国家/地区'].includes(item.colTitle)) {
              // 特殊列
              tableColumnData.push(customColumn)
            } else {
              // 普通列
              console.debug('widthVw:', widthVw)
              let className = ''
              let prop = item.colKey
              tableColumnData.push({
                prop: prop,
                label: item.colTitle,
                // widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
                //   ? this.tableCellDefaultWidthVw / 2
                //   : this.tableCellDefaultWidthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
                // className: ['arrowIcon', 'isExpand'].includes(item.colKey)
                //   ? 'expandTdClassName'
                //   : '', //单独定制的头部样式class
                widthVw,
                className,
                selected: '',
              })
            }
          }
          this.defaultWidthVwNum = tableColumnData.length - 1 //减去这1列[运动员]
          this.tableColumnData = tableColumnData
        }
        this.tableData = data.data.map((rowData) => {
          return rowData
        })
        // this.$refs.tableParentDom.scrollTo(0, 0)
        console.debug('this.tableData:', this.tableData, this.tableColumnData)
      } else {
        console.debug('暂无数据')
        this.notDataHandler()
      }
    },
    notDataHandler() {
      this.tableTotal = 0
      this.tableData = []
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  .tableScrollArea {
    position: relative;
    width: 100%;
  }
}
</style>
